import { NaNtoNumber, capitalize, displayMembershipCode } from "../../../../assets/helpers/funciones";
import { TableActionButton } from "../../../common/Buttons/Buttons";
import edit from '../../../../images/edit.svg'

const sumTotal = (data, param) => {
    let total = 0

    for (let i = 0; i < data.length; i++) {
        if (data[i]?.priceInfo) {
            total = total + data[i]?.priceInfo[param]
        }
    }
    return NaNtoNumber(total)
}

export const MultipleMembershipsTable = ({ table }) => {
    const { header, data, dollarRateByDate, membershipQuantity, actions, clientNumber } = table;

    if (data.length === 0 || !data[0]?.membershipId) {
        return null
    }
    return (
        <>
            <h5 style={{ marginTop: '12px' }}>Resumen de Membresias</h5>
            <table style={{ marginBottom: "24px" }} className="table payments-table">
                <tr>
                    {header?.map((h, i) => (
                        <th
                            key={h?.name + i}
                            style={{ display: h?.hide ? 'none' : '' }}
                        >
                            {h?.name}
                        </th>
                    ))}
                </tr>

                {Array.from({ length: membershipQuantity }).map((_, index) => (
                    <tr style={{ height: "30px", backgroundColor: index === clientNumber ? "#f27730" : "" }} key={index}>
                        <td>{data[index]?.dataTable?.year}</td>
                        <td>{data[index]?.dataTable?.class}</td>
                        <td>{data[index]?.dataTable?.armorType}</td>
                        <td>{data[index]?.dataTable?.codeType}</td>
                        <td>{data[index]?.dataTable?.code}</td>
                        <td>
                          {capitalize(
                            displayMembershipCode(data[index]?.dataTable?.plan)
                          )}
                        </td>
                        <td>{data[index]?.dataTable?.rcv}</td>
                        <td>{data[index]?.priceInfo?.finalPrice}</td>
                        <td>{data[index]?.dataTable?.class ? (NaNtoNumber(data[index]?.priceInfo?.finalPrice * dollarRateByDate)).toFixed(2) : ""}</td>
                        <td >

                            {data[index]?.dataTable?.year ?
                                <div style={{ alignItems: "center", display: "flex", justifyContent: "center", backgroundColor: index === clientNumber ? "#f27730" : "" }}>
                                    <TableActionButton src={edit} action={() => actions?.editMembership(index)} />
                                </div> : null
                            }
                        </td>
                    </tr>
                ))}
                <tr>
                    <td><b>Total</b></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><b style={{ fontSize: "16px" }}>{sumTotal(data, "finalPrice")}</b></td>
                    <td><b style={{ fontSize: "16px" }}>{(sumTotal(data, "finalPrice") * dollarRateByDate).toFixed(2)}</b></td>
                    <td></td>
                </tr>
            </table >
        </>
    )
};